// Company email signatures (CRM-1705) in previews. Mirrors the backend
// (BoomCRM::EmailSignature#body_fragment and BoomCRM::EmailSignature::Append),
// so a preview shows the signature exactly where the sent email has it.

const BODY_CONTENT = /<body[^>]*>([\s\S]*)<\/body>/i;
// React's streaming markers around the rendered editor document.
const REACT_MARKERS = /<!--\/?\$-->/g;
const BODY_CLOSE = /<\/body\s*>/gi;

// The content of the signature document's <body>, or the value as is when it
// is a fragment.
export const signatureBodyFragment = (signatureHtml: string) => {
  const cleaned = signatureHtml.replace(REACT_MARKERS, "");
  const match = BODY_CONTENT.exec(cleaned);
  return (match ? match[1] : cleaned).trim();
};

const lastBodyCloseIndex = (html: string) => {
  let index = -1;
  for (const match of html.matchAll(BODY_CLOSE)) index = match.index ?? index;
  return index;
};

// Places the signature at the end of the email content: just before </body>
// when the HTML is a whole document, otherwise after the fragment.
export const appendSignatureHtml = (
  html: string,
  signatureHtml: string | null | undefined
) => {
  const fragment = signatureHtml ? signatureBodyFragment(signatureHtml) : "";
  if (!fragment) return html;

  const index = lastBodyCloseIndex(html);
  return index === -1
    ? `${html}${fragment}`
    : `${html.slice(0, index)}${fragment}${html.slice(index)}`;
};

// "12 custom · 8 system", or "Not used".
export const formatUsedOn = ({
  custom,
  system
}: {
  custom: number;
  system: number;
}) => {
  const parts: string[] = [];
  if (custom) parts.push(`${custom} custom`);
  if (system) parts.push(`${system} system`);
  return parts.length ? parts.join(" · ") : "Not used";
};
